/**
 * Capitalizes first letter of supplied string.
 * @param string
 * @returns {string}
 */
export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}